<template>
  <div class="round-checkbox" :class="{ checked: isChecked }" @click="toggleCheck">
    <div class="checkbox-icon">
      <i class="fa fa-check" v-if="isChecked"></i>
    </div>
  </div>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.min.css'

export default {
  data () {
    return {
      isChecked: true
    }
  },
  methods: {
    toggleCheck () {
      // this.isChecked = !this.isChecked
    }
  }
}
</script>

<style scoped>
.round-checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #007bff;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: #007bff;
}

.checkbox-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fa-check {
  font-size: 12px;
  line-height: 1;
  color: white;
}

.checked .checkbox-icon {
  display: block;
}

.checked .fa-check {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/RoundCheckbox.vue